/* Estrani - kleurbolletjes op productkaarten. Gebouwd door Claude, veilig te verwijderen. */
(function () {
  'use strict';
  if (window.__aiKleurBollen) return;
  window.__aiKleurBollen = true;

  function kaartVan(dot) {
    return dot.closest('product-card') || dot.closest('.ct-card') || dot.closest('.appw-card');
  }

  function wissel(dot) {
    var kaart = kaartVan(dot);
    if (!kaart) return;
    var id = dot.getAttribute('data-media');
    var media = id ? kaart.querySelector('[data-media-id="' + id + '"]') : null;
    var slide = media && media.closest ? media.closest('slideshow-slide') : null;
    var slides = kaart.querySelector('slideshow-slides');
    if (slide && slides) {
      slide.removeAttribute('hidden');
      slide.removeAttribute('aria-hidden');
      var basis = slides.children[0] ? slides.children[0].offsetLeft : 0;
      slides.scrollTo({ left: slide.offsetLeft - basis, behavior: 'smooth' });
    } else {
      var url = dot.getAttribute('data-img');
      var img = kaart.querySelector('img');
      if (url && img) { img.removeAttribute('srcset'); img.setAttribute('src', url); }
    }
    var lijst = dot.closest('.ai-kleur');
    if (lijst) lijst.querySelectorAll('.ai-kleur__dot').forEach(function (d) {
      d.classList.remove('is-actief'); d.setAttribute('aria-pressed', 'false');
    });
    dot.classList.add('is-actief');
    dot.setAttribute('aria-pressed', 'true');

    /* Andere onderdelen op de kaart - zoals de maatrij in het productraster -
       moeten weten welke kleur nu aanstaat. */
    var naam = dot.querySelector('.ai-kleur__sr');
    try {
      kaart.dispatchEvent(new CustomEvent('ai-kleur:change', {
        bubbles: true,
        detail: { kleur: naam ? naam.textContent.trim() : '' }
      }));
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var dot = t && t.closest ? t.closest('.ai-kleur__dot') : null;
    if (!dot) return;
    e.preventDefault(); e.stopPropagation();
    wissel(dot);
  }, true);
})();
